export const EMPTY_LABEL = `\u2014`;

const getTextValue = (text?: string) => text || EMPTY_LABEL;

export default getTextValue;
